var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: { width: _vm.dialogWidth },
      on: {
        keydown: function ($event) {
          if (
            !$event.type.indexOf("key") &&
            _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
          )
            return null
          $event.preventDefault()
          return _vm.save.apply(null, arguments)
        },
      },
      model: {
        value: _vm.dialog,
        callback: function ($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog",
      },
    },
    [
      _c(
        "v-card",
        {
          staticClass: "resizable-card",
          class: { "no-select": _vm.resizing },
          style: { height: _vm.dialogHeight + "px" },
        },
        [
          _c("v-card-title", [
            _c("span", { staticClass: "headline" }, [_vm._v("Fields")]),
          ]),
          _c(
            "v-card-text",
            { staticClass: "resizable-card__body" },
            [
              _c("v-text-field", {
                attrs: {
                  disabled: "",
                  label: "UID:",
                  "hide-details": "",
                  outlined: "",
                  dense: "",
                },
                model: {
                  value: _vm.model.uid,
                  callback: function ($$v) {
                    _vm.$set(
                      _vm.model,
                      "uid",
                      typeof $$v === "string" ? $$v.trim() : $$v
                    )
                  },
                  expression: "model.uid",
                },
              }),
              _c(
                "v-row",
                { staticClass: "pt-6", attrs: { dense: "" } },
                [
                  _c(
                    "v-expansion-panels",
                    [
                      _c("r-level-track-level-field-tiles-panel", {
                        attrs: { model: _vm.model.tiles, title: "Tiles" },
                        on: {
                          "update:model": function ($event) {
                            return _vm.$set(_vm.model, "tiles", $event)
                          },
                        },
                      }),
                      _c("r-level-track-level-pattern-panel", {
                        attrs: { items: _vm.model.pattern, title: "Pattern" },
                        on: {
                          "update:items": function ($event) {
                            return _vm.$set(_vm.model, "pattern", $event)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-card-actions",
            { staticClass: "resizable-card__actions" },
            [
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  attrs: { color: "blue darken-1", text: "" },
                  on: { click: _vm.cancel },
                },
                [_vm._v(" Cancel ")]
              ),
              _c(
                "v-btn",
                {
                  attrs: { color: "blue darken-1", text: "" },
                  on: { click: _vm.save },
                },
                [_vm._v(" Save ")]
              ),
            ],
            1
          ),
          _c("div", {
            staticClass: "resize-handle",
            on: { mousedown: _vm.startResize },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }